import { motion } from "framer-motion";
import { staggerContainer, viewportOnce } from "@/lib/motion";
import { cn } from "@/lib/utils";

export function Section({ children, className, id, dense, hero }) {
  const padding = hero
    ? "pt-28 pb-16 sm:pt-32 lg:pt-36"
    : dense
      ? "py-12 sm:py-16"
      : "py-16 sm:py-20 lg:py-28";

  return (
    <motion.section
      id={id}
      className={cn(padding, "relative", className)}
      variants={staggerContainer}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
    >
      {children}
    </motion.section>
  );
}

export function Container({ children, className }) {
  return (
    <div className={cn("mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8", className)}>
      {children}
    </div>
  );
}
